import React from 'react'
function CollapsibleArrowUp(props) {
    return (
        <svg className={props.className || "upArrow" } xmlns="http://www.w3.org/2000/svg" width="12" height="9" viewBox="0 0 12 9">
        <defs>
            <clipPath>
            <rect width="12" height="9"/>
            </clipPath>
        </defs>
        <g  dataname="Arrow 2" clipPath="url(#clip-Arrow_2)">
            <rect width="12" height="9" fill="transparent"/>
            <path data-name="Path 6 Copy" d="M0,0,5,5,0,10" transform="translate(1 7) rotate(-90)" fill="none" stroke={props.color||"#808080"} strokeLinecap="round" 
            strokeLinejoin="round" strokeMiterlimit="10" strokeWidth="1"/>
        </g>
        </svg>
    )
}

export default CollapsibleArrowUp
